<template>
  <div class="card-map">

    <gmap-map
      :zoom="3"
      :center="center"
      style="width: 100%; height: 100%"
      @click="click_find_distance"
      @rightclick="rightclick_find_distance"
    >

    <template v-for="(coords, device_id) in all_coords">

      <gmap-polyline
        :path="coords"
        :key="device_id"
        :options="{
          strokeColor:'#000000',
          strokeOpacity: 1.0,
          strokeWeight: 0.5,
          icons: [{
            icon: {
              path: 1,
              scale: 3
            },
            offset: '1',
            repeat: '100px'
          }]
        }"
      />

      <gmap-marker
        v-for="(item, index) in coords"
        :key="device_id+index"
        :position="item"
        :icon="item.icon"
        :clickable="true"
        :draggable="false"
        @click="openInfoWindow(item)"
      />

    </template>

    <gmap-info-window
      :options="{maxWidth: 300, pixelOffset: {width: 0, height: -35}, content: this.info, strokeColor:'#FF0000'}"
      :position="infoWinPos"
      :opened="infoBoxOpen"
      @closeclick="infoBoxOpen=false"
    />

    <!-- Элементы карты необходимые для линейки -->

    <gmap-marker
      v-for="(marker, index) in distance_markers"
      :key="'distance'+index"
      :position="marker"
      :icon="{ url: require('assets/icons/sistematics_dist.png')}"
      :draggable="false"
    />

    <gmap-polyline
      :path="distance_markers"
      :coords.sync="distance_markers"
      :options="{
        strokeColor:'#7f058f',
        strokeOpacity: 1.0,
        strokeWeight: 3,
        icons: [{
          icon: {
            path: 0,
            scale: 3
          },
          offset: '1',
          repeat: '100px'
        }]
      }"
    />

    <gmap-info-window
      :options="{
        maxWidth: 300,
        pixelOffset: {
          width: 0,
          height: -10
        },
        content: distanceInfo,
        strokeColor:'#FF0000'
      }"
      :position="distancePos"
      :opened="distanceOpen"
      @closeclick="clear_find_distance()"
      >
    </gmap-info-window>

    <!-- Конец элементов карты необходимых для линейки -->



    </gmap-map>
  </div>
</template>

<script>


export default {
  name: 'Maps',

  props: ['all_coords', 'focus'],
  data () {
    return {
      info: '',
      infoBoxOpen: false,
      infoWinPos: {lat: 0, lng:0},
      interval: null,
      statusText: '',
      infoContent:'',
      center: {lat: 48.124, lng: 20.358},
      showdatetrack: false,
      date:[],
      show_last_position: true,
      show_last_info: true,

      distanceInfo: '',
      distanceOpen: false,
      distancePos: {lat: 0, lng:0},
      start_find: false,
      distance_markers: []
    }
  },

  watch:{
    focus(){
      if (this.focus.lat && this.focus.lng) {
        this.center = this.focus
      }
    }
  },

  computed:{
    final_distance() {
      let lat1,lon1,lat2,lon2
      for (let marker of this.distance_markers) {
        if (marker.type === 'first') {
          lat1 = marker.lat
          lon1 = marker.lng
        }else if (marker.type === 'second') {
          lat2 = marker.lat
          lon2 = marker.lng
        }
      }

      let R = 6371000; // Radius of the earth in m
      let dLat = this.deg2rad(lat2-lat1);  // deg2rad below
      let dLon = this.deg2rad(lon2-lon1);
      let a =
        Math.sin(dLat/2) * Math.sin(dLat/2) +
        Math.cos(this.deg2rad(lat1)) * Math.cos(this.deg2rad(lat2)) *
        Math.sin(dLon/2) * Math.sin(dLon/2)
        ;
      let c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
      let d = R * c; // Distance in m
      return Math.trunc(d)
    },

  },

  methods: {
    deg2rad(deg) {
      return deg * (Math.PI/180)
    },
    clear_find_distance(){
      this.distanceOpen = false
      this.distance_markers = []
    },
    click_find_distance(event){
      if (event.domEvent.ctrlKey) {
        for (let index_marker in this.distance_markers) {
          if (this.distance_markers[index_marker].type === 'first') {
            this.distance_markers.splice(index_marker, 1);
          }
        }
        let coord = {
          lat: event.latLng.lat(),
          lng: event.latLng.lng(),
          type: 'first'
        }
        this.distance_markers.push(coord)

        this.openInfoWindowDistance(coord)
      }
    },
    rightclick_find_distance(event){
      if (event.domEvent.ctrlKey) {
        for (let index_marker in this.distance_markers) {
          if (this.distance_markers[index_marker].type === 'second') {
            this.distance_markers.splice(index_marker, 1);
          }
        }
        let coord = {
          lat: event.latLng.lat(),
          lng: event.latLng.lng(),
          type: 'second'
        }
        this.distance_markers.push(coord)

        this.openInfoWindowDistance(coord)
      }
    },
    disabledTwoMonth(date) {
      const today = new Date();
      return date > new Date(today.getTime()) || date < new Date(today.getTime() - 60 * 24 * 3600 * 1000);
    },
    openInfoWindow (item) {
      this.infoWinPos = item
      this.infoBoxOpen = true
      let ts = new Date(item.ts*1000)
      let timeWindow = ('0' + ts.getHours()).slice(-2) + ':' + ('0' + ts.getMinutes()).slice(-2) + ':' + ('0' + ts.getSeconds()).slice(-2) + ' ' + ('0' + ts.getDate()).slice(-2) + '.' + ('0' + (ts.getMonth() + 1)).slice(-2) + '.' + ts.getFullYear()
      let status = timeWindow + '<br/>'
      if (item.full_name && item.fid) {
        status += item.full_name + '<br/>' + item.fid
      }
      this.info = status
    },

    openInfoWindowDistance (item) {
      if (this.final_distance) {
        this.distancePos = item
        this.distanceOpen = true
        if (this.final_distance < 999) {
          this.distanceInfo = this.final_distance + ' м'
        }else if (this.final_distance > 4999) {
          this.distanceInfo = (this.final_distance/1000) .toFixed(1) + ' км.'
        }else{
          this.distanceInfo = (this.final_distance/1000).toFixed(2) + ' км.'
        }
      }
    },
  },
}

</script>

<style lang="scss" scoped>
  .card-map{
    .content .row {
      display: flex;
      justify-content: space-between;
      align-items: flex-end;
      margin: 8px 0;

      .wrap{
        width: 89.5%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-wrap: wrap;
      }
      .btn-apply{
        width: 9.5%;
        padding: 8px 20px;
      }
      .flex-item{
        width: 24%;
        .form-group{
          margin-bottom: 0;
          label{
            font-size: 15px;
            margin-bottom: 5px;
            height: auto;
          }
        }
      }
      &::before{
        content: none;
      }
      &::after{
        content: none;
      }
    }
  }

  @media (max-width:1150px) {
    .card .content .row {
      flex-direction: column;
      align-items: flex-start;
      .wrap{
        width: 100%;
      }
      .flex-item{
        width: 49%;
        .form-group{
          margin-bottom: 15px;
        }
      }
      .btn-apply{
        width: auto;
      }
    }
  }

  @media (max-width:475px) {
    .card .content .row {
      .flex-item{
        width: 100%;
      }
    }
  }
</style>
